import axios from "axios";
import moment from "moment";
import store from "../store/index";
import axiosUrl from "./axios.service";

const API_URL = axiosUrl.getAxiosUrl();

class UserService {
  updateUser(user) {
    return axios
      .post(API_URL + "users/updateUser", {
        id: user.id.value,
        username: user.email.value,
        email: user.email.value,
        newsletterFrequency: user.newsletterFrequency.value,
        person: {
          startDate: moment(user.person.startDate.value, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
          endDate:
            user.person.endDate.value == null || user.person.endDate.value == ""
              ? null
              : moment(user.person.endDate.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                ),
          sasStartDate:
            user.person.sasStartDate.value == null ||
            user.person.sasStartDate.value == ""
              ? null
              : moment(user.person.sasStartDate.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                ),
          sasEndDate:
            user.person.sasEndDate.value == null ||
            user.person.sasEndDate.value == ""
              ? null
              : moment(user.person.sasEndDate.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                ),
          firstName: user.person.firstName.value,
          lastName: user.person.lastName.value,
          salutation: user.person.salutation.value,
          isReceivingSystemMails: user.person.isReceivingSystemMails.value,
          isAccountManager: user.person.isAccountManager.value,
          customer: user.person.customer.value,
          customerId: user.person.customerId.value,
          department: user.person.department.value,
          mobileNumber: user.person.mobileNumber.value,
          hasSasTaskEmails: user.person.hasSasTaskEmails.value
        }
      })
      .then(response => {
        store.commit("user/updateUserObject", response.data);
        store.commit("user/enableSuccessfullyUpdatedDialog");
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async getPaginationUsers(
    filterSearchTerm,
    filterByActivityStatus,
    sortBy,
    descending,
    page,
    pageSize
  ) {
    return await axios
      .get(API_URL + "users/getPaginationUsers", {
        params: {
          filterSearchTerm: filterSearchTerm,
          isActive: filterByActivityStatus,
          sortBy: sortBy,
          descending: descending,
          index: page ?? 0,
          size: pageSize ?? 50
        }
      })
      .then(response => {
        store.commit("user/updateUsersList", response.data.items);
        store.commit("user/updatePagination", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async createUser(user) {
    return await axios
      .post(API_URL + "users/addNewUser", {
        username: user.email,
        email: user.email,
        categoriesIds: user.firstCategories.concat(user.secondCategories),
        contentRoleId: user.person.contentRoleId,
        sasRoleId: user.person.sasRoleId,
        person: {
          firstName: user.person.firstName,
          lastName: user.person.lastName,
          salutation: user.person.salutation,
          customer: user.person.customer.name,
          customerId: user.person.customer.value,
          department: user.person.department,
          isReceivingSystemMails: user.person.isReceivingSystemMails,
          isAccountManager: user.person.isAccountManager,
          contentRoleId: user.person.contentRoleId,
          sasRoleId: user.person.sasRoleId,
          startDate: user.person.startDate
            ? moment(user.person.startDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : null,
          endDate:
            user.person.endDate != null
              ? moment(user.person.endDate, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null,
          hasSasTaskEmails: user.person.receivesTaskEmails,
          sasStartDate:
            user.person.sasStartDate != null
              ? moment(user.person.sasStartDate, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )
              : null
        }
      })
      .then(response => {
        if (response && response.status === 200) {
          store.commit(
            "infoModal/setInfoModalText",
            "User created successfully."
          );
          store.commit("infoModal/openInfoModal");
        }
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  addRoleToUser(selectedUserId, addRoleId) {
    return axios
      .post(API_URL + "users/addRoleToUser", {
        userId: selectedUserId,
        roleId: addRoleId
      })
      .then(response => {
        store.commit("user/updateUserObject", response.data);
        this.getAllNonRelatedRoles(response.data.id);
        store.commit("user/enableSuccessfullyUpdatedDialog");
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  removeRoleFromUser(selectedUserId, roleId) {
    return axios
      .post(API_URL + "users/removeRoleFromUser", {
        userId: selectedUserId,
        roleId: roleId
      })
      .then(response => {
        store.commit("user/updateUserObject", response.data);
        this.getAllNonRelatedRoles(response.data.id);
        store.commit("user/enableSuccessfullyUpdatedDialog");
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  deactivateUser(userId) {
    return axios
      .post(API_URL + "users/deactivateUser", {
        id: userId
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async checkIfSoftDeletedUserExists(email, customerId) {
    return await axios
      .get(API_URL + "users/checkIfSoftDeletedUserExists", {
        params: {
          email: email,
          customerId: customerId
        }
      })
      .then(response => {
        store.commit(
          "user/updateShowReactivateSoftDeletedUserModal",
          response.data
        );
        return response;
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  reactivateUser(userId) {
    return axios
      .post(API_URL + "users/reactivateUser", {
        id: userId
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }
  async anonymizeUser(userId) {
    return await axios
      .post(API_URL + "users/anonymizeUser", {
        id: userId
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }
  async resetMfaForUser(userId) {
    return await axios
      .post(API_URL + "users/resetMfa", {
        id: userId
      })
      .then(response => {
        if (response.status === 200) {
          store.commit("infoModal/setInfoModalText", "MFA successfully reset!");
          store.commit("infoModal/openInfoModal");
        }
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data);
        store.commit("user/enableModalError");
      });
  }
  async getRolesAndPermissions() {
    return await axios
      .get(API_URL + "users/getRolesAndPermissions")
      .then(response => {
        store.commit("user/updateAllRolesAndPermissions", response.data);
      });
  }

  async getRolesForCreateUser() {
    return await axios
      .get(API_URL + "users/getRolesForCreateUser")
      .then(response => {
        store.commit("user/updateRolesForCreateUser", response.data);
      });
  }

  async getSasCategories() {
    return await axios
      .get(API_URL + "users/getSasCategories")
      .then(response => {
        store.commit("user/updateCategorizations", response.data.sasCategories);
      });
  }
  async getUser(userId) {
    return await axios
      .get(API_URL + `users/getUser?userId=${userId}`)
      .then(response => {
        store.commit("user/updateUserObject", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  getUsers() {
    return axios
      .get(API_URL + "users/getUsers")
      .then(response => {
        store.commit("user/updateUsersList", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  getUsersDefaultEnv() {
    return axios
      .get(API_URL + "users/getUsersDefaultEnv")
      .then(response => {
        store.commit("user/updateUsersListDefaultEnv", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  getUsersByFilters(customerOwnerId) {
    return axios
      .get(API_URL + "users/getUsersByFilters", {
        params: {
          customerOwnerId: customerOwnerId
        }
      })
      .then(response => {
        store.commit("user/updateUsersListDefaultEnv", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  getUsersByUser(customers, customerOwnerId) {
    return axios
      .get(API_URL + "users/getUsersByUser", {
        params: {
          customers: customers != null ? customers + "" : "",
          customerOwnerId: customerOwnerId
        }
      })
      .then(response => {
        store.commit("user/updateUsersListDefaultEnv", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async getUsersByCustomerId(
    customerId,
    filterByActivityStatus,
    sortBy,
    page,
    pageSize,
    searchTerm
  ) {
    return await axios
      .get(API_URL + "users/getUsersByCustomer", {
        params: {
          customerId: customerId,
          isActive: filterByActivityStatus,
          sortBy: sortBy,
          index: page ?? 0,
          size: pageSize ?? 50,
          searchTerm: searchTerm
        }
      })
      .then(response => {
        store.commit("user/updateUsersListCustomersPage", response.data.items);
        store.commit("user/updatePaginationCustomers", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  // currently not in use
  getAllCountries() {
    return axios
      .get(API_URL + "customers/getAllCountries")
      .then(response => {
        store.commit("user/updateCountriesList", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async getAllSalutations() {
    return await axios
      .get(API_URL + "users/getAllSalutations")
      .then(response => {
        store.commit("user/updateSalutationsList", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  getAllCustomers() {
    return axios
      .get(API_URL + "users/getAllCustomers")
      .then(response => {
        store.commit("user/updateCustomersList", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async getCustomersDropdown() {
    return await axios
      .get(API_URL + "users/getCustomersDropdown")
      .then(response => {
        store.commit("user/updateCustomersDropdownList", response.data);

        // There is literally no way to do make name-value pair work properly in "q-select" tag
        // So I have this hack to click on this dropdown, because aparently that makes it load name of the item and not the id
        // Then I deselect it 10 miliseconds after. If you find a better way please do remove this and fix "UsersEditTabs.vue"
        // I have already lost 2 hours trying to make this work.
        if (document.getElementById("customersDropdownId") != null) {
          document.getElementById("customersDropdownId").click();
          setTimeout(function() {
            document
              .getElementById("customersDropdownId")
              .parentNode.parentNode.click();
          }, 10);
        }
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async getNewsletterFrequencyOptions() {
    return await axios
      .get(API_URL + "users/getNewsletterFrequencyOptions")
      .then(response => {
        store.commit(
          "user/updateNewsletterFrequencyOptionsList",
          response.data
        );
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async getNewsletterFrequencyType(userId) {
    return await axios
      .get(API_URL + "users/getFrequencyType", {
        params: {
          userId: userId
        }
      })
      .then(response => {
        store.commit("user/updateNewsletterFrequency", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async getAllNonRelatedRoles(userId) {
    return await axios
      .get(API_URL + `users/getNonRelatedRoles?userId=${userId}`)
      .then(response => {
        store.commit("user/updateRolesList", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async requestResetPassword(id) {
    return axios
      .post(API_URL + "users/requestResetPassword", {
        id: id
      })
      .then(() => {
        store.commit("user/setPasswordResetSuccessModal", true);
      })
      .catch(error => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async sendPasswordSetupMail(selectedUserId) {
    return await axios
      .post(API_URL + "users/sendPasswordSetupMail", {
        id: selectedUserId
      })
      .then(response => {
        if (response.status === 200) store.commit("user/enableEmailSentDialog");
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async deleteUser(id) {
    return await axios
      .post(API_URL + `users/deleteUser`, {
        id: id
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async getFavoriteAudienceTagsById(userId) {
    return await axios
      .get(API_URL + "Tags/GetFavoriteTagsByUserId?tagType=1", {
        params: {
          userId: userId.value
        }
      })
      .then(response => {
        if (response.status === 200) {
          store.commit("user/updateFavoriteAudiencesIdsArray", response.data);
        }
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async getFavoritePurposesTagsById(userId) {
    return await axios
      .get(API_URL + "Tags/GetFavoriteTagsByUserId?tagType=2", {
        params: {
          userId: userId.value
        }
      })
      .then(response => {
        if (response.status === 200) {
          store.commit("user/updateFavoritePurposesIdsArray", response.data);
        }
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }
  //This is just hidden for now, don't remove it:
  /*
      async getFavoriteIndustriesTags() {
        return await axios
          .get(API_URL + 'Tags/GetFavoriteTags?tagType=4')
          .then((response) => {
            if (response.status === 200) {
              store.commit('user/updateFavoriteIndustriesIdsArray', response.data);
            }
          });
      }
    */

  async getFavoriteLocationsTagsById(userId) {
    return await axios
      .get(API_URL + "Tags/GetFavoriteLocationsTagsByUserId", {
        params: {
          userId: userId.value
        }
      })
      .then(response => {
        if (response.status === 200) {
          store.commit("user/updateSelectedFavoriteLocations", response.data);
        }
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async getDefaultFilters() {
    return await axios
      .get(API_URL + `Tags/tags`, {
        params: {
          culture: "nl"
        }
      })
      .then(response => {
        store.commit("user/updateFilterActivities", response.data);
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async exportUsers(
    filterSearchTerm,
    filterByActivityStatus,
    sortBy,
    descending,
    customerId
  ) {
    return await axios
      .get(API_URL + `users/exportUsers`, {
        params: {
          filterSearchTerm: filterSearchTerm,
          isActive: filterByActivityStatus,
          sortBy: sortBy,
          descending: descending,
          customerId: customerId ? customerId : null
        },
        responseType: "blob",
        reportProgress: true
      })
      .catch(error => {
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }
}

export default new UserService();
